import React, { useEffect, useState } from "react";
import { Button, Dropdown, Modal, Form, Row, Col, Nav } from "react-bootstrap";
import NavbarVertical from "../../../src/components/navbarVertical/page";
import EmployeeNavbarVertical from "../../components/employeeNavbarVertical/page";
import NavbarPage from "../../components/navbar/page";
import PlanningSprint from "../../../src/components/planningsprint/page";
import ActiveSprint from "../../../src/components/activesprint/page";
import CompletedSprint from "../../../src/components/completedsprint/page";
import EmployeeCompletedSprint from "../../components/employeeCompletedSprint/page";
import OverviewDashboard from "../dashboard/page";
import { useLocation, Outlet, useNavigate } from "react-router-dom";
import PlanningBacklogTab from "../../components/planningsprint/PlanningBacklogTab/page";
import { postSprintTeam, getAllSprints } from "../api/sprint";
import { getAllProjectModules, createProjectModule } from "../api/Module";
import { toast } from "react-toastify";


const AdminDashboard = () => {
  const location = useLocation();
  const [showPlatformModal, setShowPlatformModal] = useState(false);
 const [activeTab, setActiveTab] = useState("overview");
  const roleId = localStorage.getItem("roleId");
  const [showAddTaskModal, setShowAddTaskModal] = useState(false);
  const [refreshBacklogKey, setRefreshBacklogKey] = useState(0);
  const [sprintstartDate, setSprintStartDate] = useState("");
  const [sprintendDate, setSprintendDate] = useState("");
  const [showSprintModal, setShowSprintModal] = useState(false);
  const [endDateError, setEndDateError] = useState(null);
  const [sprintName, setSprintName] = useState("");
  const token = localStorage.getItem("token");
  const [error, setError] = useState("");
  const [isSaving, setIsSaving] = useState(false);
  const [dateError, setDateError] = useState("");
  const [selectedSprint, setSelectedSprint] = useState(() => {
      const saved = localStorage.getItem("selectedSprint");
      return saved ? JSON.parse(saved) : null;
    });
  const [sprints, setSprints] = useState([]);
  const [isSidebarOpen, setIsSidebarOpen] = useState(true);
  const [modules, setModules] = useState([]);
  const [selectedModule, setSelectedModule] = useState(null);
  const [moduleName, setModuleName] = useState("");
  const { pathname } = useLocation();
  const navigate = useNavigate();

  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  
  const hideTabs =
    pathname.startsWith("/reporting") ||
    pathname.startsWith("/onboarddeboard");

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const tab = params.get("tab");
    if (tab) {
      if (roleId === "3" && tab === "planning") {
        setActiveTab("activeSprint");
      } else {
        setActiveTab(tab);
      }
    } else {
      setActiveTab("overview");
    }
  }, [location.search]);

  const handleStoryCreated = () => {
    setRefreshBacklogKey((prev) => prev + 1);
  };

  const isAdmin = roleId === "1" || roleId === "2";

  const handleAddTaskClose = () => {
    setShowAddTaskModal(false);
  };

  useEffect(() => {
    const fetchModules = async () => {
      try {
        const res = await getAllProjectModules(token);
        if (res.status === 200) {
          setModules(res.data);
        }
      } catch (error) {
        console.error("Error fetching modules:", error);
      }
    };

    const fetchSprints = async () => {
      try {
        const res = await getAllSprints(token);
        if (res.status === 200) {
          setSprints(res.data);
        }
      } catch (error) {
        console.error("Error fetching sprints:", error);
      }
    };

    if (token) {
      fetchModules();
      fetchSprints();
    }
  }, [token]);

  useEffect(() => {
    if (!sprints || sprints.length === 0) return;

    const today = new Date();
    today.setHours(0, 0, 0, 0);

    const currentSprint = sprints.find((sprint) => {
      const start = new Date(sprint.startDate);
      const end = new Date(sprint.endDate);
      start.setHours(0, 0, 0, 0);
      end.setHours(23, 59, 59, 999);
      return today >= start && today <= end;
    });

    if (currentSprint) {
      setSelectedSprint(currentSprint);
      localStorage.setItem("selectedSprint", JSON.stringify(currentSprint));
      window.dispatchEvent(new Event("sprintChanged"));
    }
  }, [sprints]);

  const handleSprintSelect = (sprint) => {
    setSelectedSprint(sprint);
    localStorage.setItem("selectedSprint", JSON.stringify(sprint));
    window.dispatchEvent(new Event("sprintChanged"));
  };

  const handleModuleNameChange = (e) => {
    const inputValue = e.target.value;
    setModuleName(inputValue);

    if (inputValue === "") { setError(null); return; }
    if (/^\s+$/.test(inputValue)) { setError("Module Name cannot accept spaces only."); return; }
    if (/^[0-9]+$/.test(inputValue)) { setError("Module Name cannot accept only numbers."); return; }
    if (!/[A-Za-z]/.test(inputValue)) { setError("Module Name must contain at least one letter."); return; }
    if (/^[^A-Za-z0-9\s]+$/.test(inputValue)) { setError("Module Name cannot accept only special characters."); return; }
    setError(null);
  };

  const handleSavePlatform = async () => {
    if (/^\s*$/.test(moduleName)) {
      setError(moduleName === "" ? "Module Name is required." : "Module Name cannot accept spaces only.");
      return;
    }
    const trimmedName = moduleName.trim();
    if (/^[0-9]+$/.test(trimmedName)) { setError("Module Name cannot accept only numbers."); return; }
    if (/^[^A-Za-z0-9\s]+$/.test(trimmedName)) { setError("Module Name cannot accept only special characters."); return; }
    if (!/[A-Za-z]/.test(trimmedName)) { setError("Module Name must contain at least one letter."); return; }

    setError(null);
    setIsSaving(true);
    try {
      const response = await createProjectModule({ projectModuleName: trimmedName }, token);
      if (response.status === 200) {
        toast.success("Module created successfully!");
        setModuleName("");
        setShowPlatformModal(false);
        const updatedModules = await getAllProjectModules(token);
        if (updatedModules.status === 200) setModules(updatedModules.data);
      } else {
        setError("Failed to save module");
      }
    } catch (err) {
      console.error(err);
      setError("Module already exists");
    } finally {
      setIsSaving(false);
    }
  };

  const handleCancelPlatform = () => {
    setModuleName("");
    setError("");
    setShowPlatformModal(false);
  };

  const handleSprintNameChange = (e) => {
    const inputValue = e.target.value;
    setSprintName(inputValue);
    if (inputValue === "") { setError(null); return; }
    if (/^\s*$/.test(inputValue)) { setError("Sprint Name cannot accept spaces only."); return; }
    const trimmedValue = inputValue.trim();
    if (/^[0-9]+$/.test(trimmedValue)) { setError("Sprint Name cannot accept only numbers."); return; }
    if (!/[A-Za-z]/.test(inputValue)) { setError("Sprint Name must contain at least one letter."); return; }
    if (/^[^A-Za-z0-9\s]+$/.test(trimmedValue)) { setError("Sprint Name cannot accept only special characters."); return; }
    setError(null);
  };

  const handleSaveSprint = async () => {
    const trimmedSprintName = sprintName.trim();
    let hasError = false;

    if (sprintName === "") { setError("Sprint Name is required."); hasError = true; }
    else if (/^\s+$/.test(sprintName)) { setError("Sprint Name cannot accept spaces only."); hasError = true; }
    else if (/^[0-9]+$/.test(trimmedSprintName)) { setError("Sprint Name cannot accept only numbers."); hasError = true; }
    else if (!/[A-Za-z]/.test(trimmedSprintName)) { setError("Sprint Name must contain at least one letter."); hasError = true; }
    else if (/^[^A-Za-z0-9\s]+$/.test(trimmedSprintName)) { setError("Sprint Name cannot accept only special characters."); hasError = true; }
    else { setError(null); }

    if (!sprintstartDate) { setDateError("Start Date is required."); hasError = true; }
    else { setDateError(null); }

    if (!sprintendDate) { setEndDateError("End Date is required."); hasError = true; }
    else if (sprintstartDate && sprintendDate < sprintstartDate) { setEndDateError("End Date cannot be earlier than Start Date."); hasError = true; }
    else { setEndDateError(null); }

    if (hasError) return;

    setIsSaving(true);
    const request = { sprintName: trimmedSprintName, startDate: sprintstartDate, endDate: sprintendDate };

    try {
      const response = await postSprintTeam(request, token);
      if (response.status === 200) {
        toast.success("Sprint created successfully!");
        setSprintName("");
        setSprintStartDate("");
        setSprintendDate("");
        setShowSprintModal(false);
        const updatedSprints = await getAllSprints(token);
        if (updatedSprints.status === 200) {
          setSprints(updatedSprints.data);
          window.dispatchEvent(new Event("sprintListUpdated"));
        }
      } else {
        setError(response.message || "Failed to save sprint");
      }
    } catch (err) {
      console.error("Error creating sprint:", err);
      setError(err.response?.data?.message || "An error occurred while saving");
    } finally {
      setIsSaving(false);
    }
  };

  useEffect(() => {
    const handleSprintUpdate = async () => {
      const res = await getAllSprints(token);
      if (res.status === 200) setSprints(res.data);
    };
    window.addEventListener("sprintListUpdated", handleSprintUpdate);
    return () => window.removeEventListener("sprintListUpdated", handleSprintUpdate);
  }, [token]);

 useEffect(() => {
    const handleSprintChanged = () => {
      const saved = localStorage.getItem("selectedSprint");
      setSelectedSprint(saved ? JSON.parse(saved) : null);
    };
    window.addEventListener("sprintChanged", handleSprintChanged);
    return () => window.removeEventListener("sprintChanged", handleSprintChanged);
  }, []);
  
  useEffect(() => {
    const handleTabChange = (event) => {
      setActiveTab(event.detail);
    };
    window.addEventListener("changeSprintTab", handleTabChange);
    return () => window.removeEventListener("changeSprintTab", handleTabChange);
  }, []);

  return (
    <>
      <NavbarPage />
      <aside
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          width: isSidebarOpen ? 250 : 60,
          height: "calc(100vh - 60px)",
          transition: "width 0.3s ease",
          zIndex: 900,
        }}
      >
        
      {roleId === "3" ? (
  <EmployeeNavbarVertical
    isOpen={isSidebarOpen}
    onToggle={() => setIsSidebarOpen(!isSidebarOpen)}
  />
) : (
  <NavbarVertical
    isOpen={isSidebarOpen}
    onToggle={() => setIsSidebarOpen(!isSidebarOpen)}
  />
)}
      </aside>

      <main
        style={{
          marginLeft: isSidebarOpen ? 250 : 60,
          transition: "margin-left 0.3s ease",
          marginTop: 60,
          padding: "0px 16px 16px 16px",
          minHeight: "calc(100vh - 60px)",
          overflowX: "hidden",
          overflowY: "auto",
        }}
      >
        {!hideTabs && activeTab !== "overview" && (
          <>
            {/* ── TAB NAVIGATION BAR ── */}
            <div
              style={{
                background: "#fff",
                padding: "0 16px",
                marginBottom: "16px",
                position: "sticky",
                top: 0,
                zIndex: 800,
              }}
            >
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  gap: "0",
                  overflowX: "auto",
                  flexWrap: "nowrap",
                  msOverflowStyle: "none",
                  scrollbarWidth: "none",
                }}
              >
                {/* Left: tabs */}
                <div style={{ display: "flex", alignItems: "center" }}>
                  {[
                    { key: "planning", label: "Planning / Backlog", hideFor: ["3"] },
                    { key: "activeSprint", label: "Active Sprint", hideFor: [] },
                    { key: "completed", label: "Completed Sprint", hideFor: [] },
                  ].filter((tab) => !tab.hideFor.includes(roleId)).map((tab) => (
                    <button
                      key={tab.key}
                      onClick={() => {
                        setActiveTab(tab.key);
                        navigate("/admin-dashboard?tab=" + tab.key);
                      }}
                      style={{
                        padding: "14px 20px",
                        border: "none",
                        borderBottom:
                          activeTab === tab.key
                            ? "2px solid #1d4ed8"
                            : "2px solid transparent",
                        background: "none",
                        cursor: "pointer",
                        fontSize: "14px",
                        fontWeight: activeTab === tab.key ? "600" : "400",
                        color:
                          activeTab === tab.key ? "#1d4ed8" : "#6b7280",
                        transition: "all 0.15s",
                        whiteSpace: "nowrap",
                      }}
                    >
                      {tab.label}
                    </button>
                  ))}
                </div>

                {!isMobile && activeTab === "activeSprint" && (

                  <div style={{ display: "flex", alignItems: "center", gap: "8px", paddingRight: "4px" }}>
                    {/* All filter dropdown */}
                    <Dropdown>
                      <Dropdown.Toggle
                        variant="light"
                        size="sm"
                        style={{
                          border: "1px solid #d1d5db",
                          background: "#fff",
                          color: "#374151",
                          fontWeight: "400",
                          fontSize: "13px",
                          display: "flex",
                          alignItems: "center",
                          gap: "4px",
                          borderRadius: "6px",
                          padding: "5px 10px",
                        }}
                      >
                        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ marginRight: "2px" }}>
                          <polygon points="22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3" />
                        </svg>
                        All
                      </Dropdown.Toggle>
                      <Dropdown.Menu>
                        <Dropdown.Item>All</Dropdown.Item>
                      </Dropdown.Menu>
                    </Dropdown>

                    {/* Active sprint name — static label */}
                    {selectedSprint && (
                      <span style={{
                        border: "1px solid #d1d5db",
                        background: "#fff",
                        color: "#374151",
                        fontWeight: "500",
                        fontSize: "13px",
                        borderRadius: "6px",
                        padding: "5px 10px",
                      }}>
                        {selectedSprint.sprintName}
                      </span>
                    )}

                  </div>
                )}
             </div>
            </div>

            {/* ── Mobile FAB for activeSprint ── */}
{isMobile && activeTab === "activeSprint" && (
  <div style={{
    position: "fixed", bottom: 24, right: 20,
    display: "flex", flexDirection: "row", alignItems: "center",
    gap: 8, zIndex: 1200,
  }}>
  </div>
)}

            {/* ── TAB CONTENT ── */}
            {activeTab === "planning" && roleId !== "3" && (
              <PlanningBacklogTab refreshKey={refreshBacklogKey} />
            )}

            {activeTab === "activeSprint" && <ActiveSprint />}

            {activeTab === "completed" && (
              roleId === "6" ? <EmployeeCompletedSprint /> : <CompletedSprint />
            )}
          </>
        )}

        {!hideTabs && activeTab === "overview" && <OverviewDashboard />}

        <Outlet />
      </main>

      {/* ── Modals (unchanged) ── */}
      <Modal show={showAddTaskModal} onHide={handleAddTaskClose} size="lg">
        <Modal.Header closeButton>
          <Modal.Title>Backlog Stories</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <PlanningSprint
            onSave={handleStoryCreated}
            onClose={handleAddTaskClose}
          />
        </Modal.Body>
      </Modal>

      <Modal show={showPlatformModal} onHide={handleCancelPlatform} centered>
        <Modal.Header closeButton>
          <Modal.Title>Add New Platform</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <>
            <Form.Label htmlFor="inputteam">
              Module Name<span className="text-danger">*</span>
            </Form.Label>
            <Form.Control
              type="text"
              id="inputteam"
              placeholder="Enter Module Name"
              value={moduleName}
              onChange={(e) => handleModuleNameChange(e)}
            />
            {error && <div className="text-danger mt-2">{error}</div>}
          </>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCancelPlatform}>
            Close
          </Button>
          <Button variant="primary" onClick={handleSavePlatform} disabled={isSaving}>
            {isSaving ? "Saving..." : "Save"}
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal
        show={showSprintModal}
        onHide={() => {
          setSprintName("");
          setSprintStartDate("");
          setSprintendDate("");
          setError(null);
          setDateError(null);
          setEndDateError(null);
          setShowSprintModal(false);
        }}
      >
        <Modal.Header closeButton>
          <Modal.Title>Add New Sprint</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <>
            <Row className="mb-2">
              <Col>
                <Form.Label htmlFor="inputsprint">
                  Sprint Name<span className="text-danger">*</span>
                </Form.Label>
                <Form.Control
                  type="text"
                  id="inputsprint"
                  placeholder="Enter Sprint Name"
                  value={sprintName}
                  onChange={handleSprintNameChange}
                />
                {error && (
                  <div style={{ color: "red", fontSize: "0.875rem", marginTop: "4px" }}>
                    {error}
                  </div>
                )}
              </Col>
            </Row>
            <Row className="mb-2">
              <Col>
                <Form.Label htmlFor="inputDate">
                  Start Date<span className="text-danger">*</span>
                </Form.Label>
                <Form.Control
                  type="date"
                  id="inputDate"
                  value={sprintstartDate}
                  onChange={(e) => {
                    const selectedStartDate = e.target.value;
                    setSprintStartDate(selectedStartDate);
                    setDateError(null);
                    setEndDateError(null);
                    if (sprintendDate) {
                      setSprintendDate("");
                      setEndDateError(null);
                    }
                  }}
                  onClick={(e) => {
                    if (e.target.showPicker) e.target.showPicker();
                  }}
                />
                {dateError && (
                  <div style={{ color: "red", fontSize: "0.875rem", marginTop: "4px" }}>
                    {dateError}
                  </div>
                )}
              </Col>
            </Row>
            <Row className="mb-2">
              <Col>
                <Form.Label htmlFor="inputendDate">
                  End Date<span className="text-danger">*</span>
                </Form.Label>
                <Form.Control
                  type="date"
                  id="inputendDate"
                  value={sprintendDate}
                  min={sprintstartDate || ""}
                  onChange={(e) => setSprintendDate(e.target.value)}
                  onClick={(e) => {
                    if (!sprintstartDate) {
                      setEndDateError("Please select the Start Date first.");
                      e.preventDefault();
                    } else {
                      setEndDateError(null);
                      if (e.target.showPicker) e.target.showPicker();
                    }
                  }}
                />
                {endDateError && (
                  <div style={{ color: "red", fontSize: "0.875rem", marginTop: "4px" }}>
                    {endDateError}
                  </div>
                )}
              </Col>
            </Row>
          </>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => {
              setSprintName("");
              setSprintStartDate("");
              setSprintendDate("");
              setError(null);
              setDateError(null);
              setEndDateError(null);
              setShowSprintModal(false);
            }}
          >
            Close
          </Button>
          <Button variant="primary" onClick={handleSaveSprint} disabled={isSaving}>
            {isSaving ? "Saving..." : "Save"}
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default AdminDashboard;
